import { Skeleton } from '@mui/material'
import { AppEntitlementInfoDrawer } from 'components/pages/explore/visibility/info-drawers/AppEntitlementInfoDrawer'
import { AppEntitlementValue, getAppEntitlement } from 'lib/actions/apps/app-entitlement'
import { NotifyClient } from 'lib/notify'
import { AppEntitlementsReducer, initialAppEntitlementsState } from 'lib/reducers/apps/entitlement'
import { Status } from 'lib/rpc'
import { useClientRPC } from 'lib/rpcts'
import { AppEntitlementsClient } from 'pbts/c1/api/app/v1/app_entitlement.client'
import React, { useEffect, useReducer, useState } from 'react'

export type EntitlementsDrawerPropsWithFetchParams = {
    appId: string
    entitlementId: string
    notifySvc?: NotifyClient
    entitlement?: never
}

export type EntitlementsDrawerPropsWithEntitlement = {
    appId?: never
    entitlementId?: never
    notifySvc?: never
    entitlement: AppEntitlementValue
}

type EntitlementsDrawerProps = EntitlementsDrawerPropsWithFetchParams | EntitlementsDrawerPropsWithEntitlement

export const EntitlementsDrawer = ({
    appId,
    entitlementId,
    notifySvc,
    entitlement,
}: EntitlementsDrawerProps): React.ReactElement => {
    if (entitlement) {
        return <AppEntitlementInfoDrawer entitlement={entitlement} />
    } if (appId && entitlementId) {
        return <EntitlementsDrawerWithFetch appId={appId} entitlementId={entitlementId} notifySvc={notifySvc} />
    }
    return <Skeleton />
}

export const EntitlementsDrawerWithFetch = ({
    appId,
    entitlementId,
    notifySvc,
}: EntitlementsDrawerPropsWithFetchParams): React.ReactElement => {
    const entitlementClient = useClientRPC<AppEntitlementsClient>(AppEntitlementsClient)
    const [entitlementState, entitlementDispatch] = useReducer(AppEntitlementsReducer, initialAppEntitlementsState)
    const [entitlementObj, setEntitlementObj] = useState<AppEntitlementValue | undefined>(undefined)

    useEffect(() => {
        if (!entitlementClient || entitlementId === '' || appId === '') {
            return
        }

        getAppEntitlement(entitlementDispatch, entitlementClient, entitlementId, appId, notifySvc)
    }, [entitlementClient, entitlementDispatch, notifySvc, entitlementId, appId])

    useEffect(() => {
        if (entitlementState.item.status !== Status.OK) {
            return
        }

        setEntitlementObj(entitlementState.item.item)
    }, [entitlementClient, entitlementState.item])

    if (!entitlementObj) {
        return <Skeleton />
    }

    return <AppEntitlementInfoDrawer entitlement={entitlementObj} />
}
